import React from 'react';
import Radium from 'radium';
import Loader from 'views/Loader';

export const ThumbnailLoader = (props) => {

	return <Loader style={{height: '442px', width: '442px', flexGrow: "1", maxWidth: '500px', marginRight: '20px', marginBottom: '10px',
							 '@media (max-width: 884px)': {width: '100%', marginRight: '0', height: '300px'}}} noEffect={true} />;
};

const OrderFormLoder = Radium((props) => {


	return <div className="flexRow" style={{paddingTop: '20px'}}>
			<ThumbnailLoader />
			<div style={{flexGrow: "1", maxWidth: "500px"}}>
				<Loader style={{height: '35px', width: '50%', marginBottom: '15px' }}/>

				<Loader style={{height: '15px', width: '30%' }}/>

				<Loader style={{height: '30px', width: '25%', margin: '40px 0' }}/>

				<hr />

				<div className='flexRow' style={{marginTop: '40px'}}>
					<Loader style={{height: '100px', width: '100px', marginRight: '10px' }} noEffect={true}/>
					<Loader style={{height: '100px', width: '100px', marginRight: '10px' }} noEffect={true}/>
				</div>

				<Loader style={{height: '30px', width: '100%', marginTop: '30px' }} noEffect={true}/>

				<Loader style={{height: '30px', width: '100%', marginTop: '30px' }} noEffect={true}/>
			</div>
		</div>
});


export default OrderFormLoder;


// WEBPACK FOOTER //
// ./src/views/order/OrderFormLoader.js